import Profissional from "@/model/Profissional";
import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    Listar: async () => {
        const response = await httpClient.get(`/Profissional/listar`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pId : number) => {
        const response = await httpClient.get(`/Profissional/id?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (profissional : Record<string,Profissional>) => {
        const response = await httpClient.post(`/Profissional/inserir`, profissional);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (profissional: Record<string,Profissional>) => {
        const response = await httpClient.post(`Profissional/alterar`, profissional);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pId : number) => {
        const response = await httpClient.post(`Profissional/excluir?id=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    EspecialidadePorProfissional: async (pIdProfissional : number) => {
        const response = await httpClient.get(`Profissional/especialidadeListar?pIdProfissional=${pIdProfissional}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    EspecialidadeExisteNoProfissional: async (pIdProfissional : number, pIdEspecialidade : number) => {
        const response = await httpClient.get(`Profissional/existeEsp?pIdProfissional=${pIdProfissional}&pIdEspecialidade=${pIdEspecialidade}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    InserirEspecialidadeNaLista: async (pIdProfissional : number, pIdEspecialidade: number, pPrincipal : boolean) => {
        const response = await httpClient.post(`/Profissional/especialidadeInserir?pIdProfissional=${pIdProfissional}&pIdEspecialidade=${pIdEspecialidade}&principal=${pPrincipal}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ExcluirEspecialidadeNaLista: async (pIdProfissional : number, pIdEspecialidade: number) => {
        const response = await httpClient.post(`/Profissional/especialidadeExcluir?pIdProfissional=${pIdProfissional}&pIdEspecialidade=${pIdEspecialidade}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    MudarPrincipal: async (pIdProfissional : number, pIdEspecialidade: number) => {
        const response = await httpClient.post(`/Profissional/especialidadePrincipal?pIdProfissional=${pIdProfissional}&pIdEspecialidade=${pIdEspecialidade}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaListar: async (pIdProfissional : number, pDia? : number) => {
        const response = await httpClient.get(`/Profissional/agendaListar?pIdProfissional=${pIdProfissional}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaExiste: async (pIdProfissional : number, pData : Date, pItem: number) => {
        const response = await httpClient.get(`/Profissional/existeAgenda?pIdProfissional=${pIdProfissional}&Dia=${pData}&HrInicial=${pData}&HrFinal=${pData}&Item=${pItem}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaInserir: async (ProfissionalAgenda : Record<string,unknown>) => {
        const response = await httpClient.post(`/Profissional/agendaInserir`,ProfissionalAgenda);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaAlterar: async (ProfissionalAgenda: Record<string,unknown>) => {
        const response = await httpClient.post(`/Profissional/agendaEditar`, ProfissionalAgenda);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProfissionalAgendaExcluir: async (pIdProfissional : number, pItem: number) => {
        const response = await httpClient.post(`/Profissional/agendaExcluir?pIdProfissional=${pIdProfissional}&pItem=${pItem}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },

});